import React from "react";
import Disqus from "disqus-react";

const comments = props => {
  const disqusShortname = "fa2020manoj";
  const disqusConfig = {
    url:
      "http://fabacademy.org/2020/labs/vigyanashram/students/manojsahukar/#!" +
      "/" +
      props.id,
    identifier: props.id,
    title: props.title
  };
  return (
    <div>
      <Disqus.DiscussionEmbed
        shortname={disqusShortname}
        config={disqusConfig}
      />
    </div>
  );
};

export default comments;
